import * as React from "react";
import { useCommonHooks, useEditRouteParams } from "../../../hooks";
import { useQuery } from "react-query";
import { ERoutes } from "../../../AppRouter";
import { Spinner, SpinnerSize, Tab, Tabs } from "@blueprintjs/core";
import { BackButton, PageBase } from "../../../components";
import ObjectiveQuestionDetailPanel from "./ObjectiveQuestionDetailPanel";

export interface IObjectiveQuestionItemPageProps {}

export const ObjectiveQuestionItemPage: React.FunctionComponent<
  IObjectiveQuestionItemPageProps
> = () => {
  const { t, router, apis } = useCommonHooks();
  const { id, tab } = useEditRouteParams();

  const { data: displayName, isFetching: loadingDisplayName } = useQuery(
    ["objective-question-display-name", id],
    async () => {
      if (+id > 0) {
        return await apis.objectiveQuestions.getDisplayName(+id);
      }
      return t("NewObjectiveQuestion");
    }
  );

  const breadCrumbs = React.useMemo(() => {
    return [
      { text: t("ObjectiveQuestionList"), route: ERoutes.objectiveQuestions },
      {
        text: loadingDisplayName ? (
          <Spinner size={SpinnerSize.SMALL} />
        ) : (
          displayName.text
        ),
      },
    ];
  }, [displayName, loadingDisplayName, t]);

  return (
    <PageBase breadCrumbs={breadCrumbs}>
      <Tabs
        selectedTabId={tab}
        onChange={(nextTabId) =>
          router.push(`${ERoutes.objectiveQuestions}/${id}/${nextTabId}`)
        }
      >
        <BackButton backRoute={ERoutes.objectiveQuestions} />
        <Tab
          id="details"
          title={t("Details")}
          panel={<ObjectiveQuestionDetailPanel objectiveQuestionId={+id} />}
        />
      </Tabs>
    </PageBase>
  );
};

export default ObjectiveQuestionItemPage;
